<div class="report-container">
  <div class="report-header">
    <div class="title-section">
      <h2 class="modern-title">Cost of Goods Sold (COGS)</h2>
      <p class="modern-subtitle">Inventory valuation and depletion tracking</p>
    </div>

    <div class="controls-section">
      <div class="btn-group modern-btn-group">
        @for (p of periods; track p) {
          <button
            class="btn modern-filter-btn"
            [class.active]="period === p"
            (click)="setPeriod(p)">
            {{ p }}
          </button>
        }
      </div>

      @if (period === 'Custom') {
        <div class="custom-date-section ms-3 d-flex align-items-center">
          <input type="date" [(ngModel)]="startDate" class="date-input">
          <span class="mx-2" style="color: white">to</span>
          <input type="date" [(ngModel)]="endDate" class="date-input">
          <button class="btn modern-action-btn primary-btn ms-2" (click)="applyCustomRange()">Apply</button>
        </div>
      }

      <button class="btn modern-action-btn primary-btn ms-3" (click)="exportPdf()">
        Export PDF
      </button>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-cards">
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Beginning Inventory</div>
        <div class="card-value text-inventory">{{ beginningInventory | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Purchases</div>
        <div class="card-value text-purchase">+ {{ purchases | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card highlight-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Cost of Goods Sold</div>
        <div class="card-value text-cogs">- {{ totalCogs | currency }}</div>
      </div>
    </div>
    <div class="summary-card glass-card">
      <div class="card-details">
        <div class="card-period">{{ period }}</div>
        <div class="card-label">Ending Inventory</div>
        <div class="card-value text-inventory">{{ endingInventory | currency }}</div>
      </div>
    </div>
  </div>

  <!-- Chart Section -->
  <div class="chart-section glass-card mt-4 mb-4">
    <div class="section-header d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <h3 class="section-title text-white mb-0">Operational Analytics</h3>
        <span class="ms-2 period-tag">{{ period }}</span>
      </div>
      <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle operational analytics" title="Toggle operational analytics" (click)="isChartCollapsed = !isChartCollapsed"></button>
    </div>
    <div [collapse]="isChartCollapsed" [isAnimated]="true">
      <div class="chart-wrapper">
        <div class="row h-100 g-0">
          <div class="col-md-6 border-end border-white border-opacity-10">
            @if (chartOptions) {
              <ag-charts [options]="chartOptions" style="height: 100%"></ag-charts>
            }
          </div>
          <div class="col-md-6">
            @if (comparisonOptions) {
              <ag-charts [options]="comparisonOptions" style="height: 100%"></ag-charts>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detailed Breakdown Table -->
  <div class="breakdown-card glass-card mt-4">
    <div class="section-header d-flex justify-content-between align-items-center mb-3"
      (click)="isBreakdownCollapsed = !isBreakdownCollapsed"
      style="cursor: pointer">
      <div class="d-flex align-items-center">
        <h3 class="section-title text-white mb-0">Inventory Valuation by Category</h3>
        <span class="ms-2 period-tag">{{ period }}</span>
      </div>
      <button class="btn btn-link text-white p-0" type="button" aria-label="Toggle inventory valuation" title="Toggle inventory valuation"></button>
    </div>

    <div [collapse]="isBreakdownCollapsed" [isAnimated]="true">
      <div class="table-responsive">
        <table class="table modern-table table-hover">
          <thead>
            <tr>
              <th class="text-white border-bottom border-secondary">Category</th>
              <th class="text-white border-bottom border-secondary text-end">Beginning</th>
              <th class="text-white border-bottom border-secondary text-end">Purchased</th>
              <th class="text-white border-bottom border-secondary text-end">COGS</th>
              <th class="text-white border-bottom border-secondary text-end">Ending Value</th>
            </tr>
          </thead>
          <tbody>
            @for (row of cogsBreakdown; track row) {
              <tr>
                <td style="color: white">{{ row.category }}</td>
                <td class="text-end" style="color: white">{{ row.beginning | currency }}</td>
                <td class="text-end text-purchase">+ {{ row.purchased | currency }}</td>
                <td class="text-end text-cogs">- {{ row.cogs | currency }}</td>
                <td class="text-end fw-medium" style="color: white">{{ row.ending | currency }}</td>
              </tr>
            }
            <!-- Totals Row -->
            <tr class="table-active">
              <td class="fw-medium text-white border-top border-secondary">TOTAL</td>
              <td class="text-end fw-medium text-white border-top border-secondary">{{ beginningInventory | currency }}</td>
              <td class="text-end fw-medium text-purchase border-top border-secondary">+ {{ purchases | currency }}</td>
              <td class="text-end fw-medium text-cogs border-top border-secondary">- {{ totalCogs | currency }}</td>
              <td class="text-end fw-medium text-white border-top border-secondary">{{ endingInventory | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>



</div>
